import React, {PropTypes} from 'react';
import Consts from '../../../Consts';

class ActionButton extends React.Component {
    constructor(props) {
        super(props);
        this.invokeAction = this.invokeAction.bind(this);
        this.state = {clicked: false}
    }

    invokeAction(event){  
        event.preventDefault();  
        if(this.props.valid){
            this.setState({clicked: true});
            this.props.action();
        }
    }

    componentWillReceiveProps(newProps){
        this.setState({clicked: false});
    }

    render() {
    return (
            <a href='#' className={(this.props.className?this.props.className:"c-Btn c-Btn--primary u-mb6")+((this.props.valid && !this.state.clicked)?"":" is-disabled")} onClick={this.invokeAction}>
                {(this.state.clicked)?<img src={Consts.baseDir+"images/spinner.svg"} />:this.props.text}
            </a>               
        );
    }
}

ActionButton.propTypes = {
    text: React.PropTypes.string.isRequired,
    className: React.PropTypes.string,
    valid: React.PropTypes.bool.isRequired,
    action: React.PropTypes.func
};


export default ActionButton;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Subcomponents/ActionButton.js
 **/